<div class="fieldvalues-inspector">
  <div class="inspector-header">
    <h3>Inspect Form Metadata</h3>
    <span class="inspector-summary" *ngIf="!isLoading && !errorMessage">
      {{ viewForms.length }} form(s) shown
    </span>
  </div>

  <div class="filter-bar" *ngIf="!isLoading && !errorMessage">
    <label class="filter-input">
      <span class="filter-input__label">Filter by form</span>
      <input type="text"
             [ngModel]="formNameFilter"
             (ngModelChange)="onFormNameFilterChange($event)"
             placeholder="Country / form / tool / version" />
    </label>
    <label class="filter-input">
      <span class="filter-input__label">Filter by key</span>
      <input type="text"
             [ngModel]="keyFilter"
             (ngModelChange)="onKeyFilterChange($event)"
             placeholder="e.g. CPACertification, HasFormPreview" />
    </label>
  </div>

  <div *ngIf="isLoading" class="inspector-state">Loading…</div>
  <div *ngIf="errorMessage" class="inspector-state inspector-state--error">{{ errorMessage }}</div>

  <div *ngIf="!isLoading && !errorMessage && !allForms.length"
       class="inspector-state">
    No live forms found.
  </div>
  <div *ngIf="!isLoading && !errorMessage && allForms.length && !viewForms.length"
       class="inspector-state">
    No forms match the current filter.
  </div>

  <ng-container *ngIf="!isLoading && !errorMessage && viewForms.length">
    <section class="form-card"
             *ngFor="let f of viewForms; trackBy: trackByForm">
      <header class="form-card__header">
        <span class="form-card__title">{{ f.title }}</span>
        <div class="form-card__actions">
          <span class="form-card__count">{{ f.entries.length }} field(s)</span>
          <button type="button"
                  class="form-card__edit"
                  title="Edit metadata"
                  (click)="onEditCard(f)">
            <i class="fa-solid fa-pen"></i>
            <span>Edit</span>
          </button>
        </div>
      </header>
      <div class="form-card__body">
        <div *ngIf="!f.entries.length" class="empty-placeholder">(empty)</div>
        <div *ngIf="f.entries.length" class="field-entries">
          <div class="field-entry"
               *ngFor="let e of f.entries; trackBy: trackByEntry">
            <div class="field-entry__key">{{ e.key }}</div>
            <div class="field-entry__value">{{ e.value }}</div>
          </div>
        </div>
      </div>
    </section>
  </ng-container>
</div>
